// extracted by mini-css-extract-plugin
module.exports = {"Empty":"empty_Empty__Nr18S","EmptyLinks":"empty_EmptyLinks__DYQb5"};